import { useMemo } from 'react';
import { CSVLink } from 'react-csv';
import { dateFormat, timeFormat } from 'utils/helpers';

interface CSVProps {
    data: object[];
    headers?: object[];
    fileName?: string;
    children?: React.ReactNode;
}

const DownloadCSV = ({ data, headers, fileName = 'Catholic', children }: CSVProps) => {
    const props: any = { filename: fileName };
    if (headers) {
        props.headers = headers;
    }

    const normalizeData = useMemo(() => {
        const _data = [...data];
        return _data.map((item: any) => {
            let _item = { ...item };
            Object.keys(item).forEach((key: string) => {
                if (key.toLowerCase().includes('date')) {
                    _item = {
                        ...item,
                        time: timeFormat(item[key], 'hh:mm A'),
                        date: dateFormat(item[key]),
                    };
                }
            });
            return _item;
        });
    }, [data]);
    return (
        <CSVLink data={normalizeData} {...props}>
            {children || 'Export to csv'}
        </CSVLink>
    );
};

export default DownloadCSV;
